/**
 * Privacy Settings Colors Enum
 * Following the pattern of BrandfolderHexColors from @/library/utils/types/colors.ts
 * Contains all colors used across privacy settings components
 */

export enum PrivacySettingsColors {
  // Primary Brand Colors (from existing BrandfolderHexColors)
  PurplePopsicle = '#4462C9',
  PurplePopsicleHover = '#314CA9',

  // Error/Alert Colors
  ErrorBackground = '#fcedef',
  ErrorText = '#ad2334',
  ErrorBorder = '#BD2D3F',

  // Success Colors
  SuccessBackground = '#e8f5f0',
  SuccessBorder = '#d1e7dd',
  SuccessTextDark = '#0f5132',
  SuccessText = '#198754',

  // Info Colors
  InfoBackground = '#d9edf7',
  InfoText = '#346D99',

  // Neutral/Gray Colors
  LightGrayBackground = '#f8f9fa',
  MutedText = '#6c757d',
  DarkText = '#353A4A',
  VeryDarkText = '#101524',
  BorderGray = '#dee2e6',
  PlaceholderText = '#8F929C',
  DisabledBackground = '#e9ecef',
  DisabledText = '#4E5363',
  SecondaryText = '#727682',

  // Form Colors
  FormBorder = '#d1d5db',
  FormText = '#374151',
  FocusBorder = '#4f46e5',

  // Core Colors
  White = '#FFFFFF',
  Black = '#000000',

  // Legacy SCSS variable mappings (for backward compatibility)
  Text = '#4A4A4A',
  Title = '#333333',
  Marshmallow = '#F9FBFC',
  WarningRed = '#F64E63',
  SuccessGreen = '#04B08C',
  GrayDark = '#6f6f6f',
}

// Type for color keys (useful for TypeScript autocomplete)
export type PrivacySettingsColorKey = keyof typeof PrivacySettingsColors;
